/*
 * Organização dos itens da venda para exibição.
 *
 * O backend devolve todos os registros de tb_vendas_item, principais e componentes de produtos
 * compostos, já ordenados. ID_Composto aponta para o item principal, mas o SMD não garante se o
 * valor é a sequência ou o id do registro — por isso a hierarquia só é montada quando *todos* os
 * componentes resolvem pela mesma chave. Não resolvendo, a lista volta plana: o requisito é nunca
 * ocultar um item, e adivinhar o vínculo colocaria o componente sob o produto errado.
 */

export const NIVEL_PRINCIPAL = 0
export const NIVEL_COMPONENTE = 1

export const ehComponente = item => Number(item?.ID_Composto || 0) > 0

const indexarPor = (itens, campo) => {
  const indice = new Map()
  itens.forEach(item => indice.set(Number(item[campo]), item))
  return indice
}

const resolveTodos = (componentes, indice) =>
  componentes.every(componente => indice.has(Number(componente.ID_Composto)))

const listaPlana = itens => itens.map(item => ({
  ...item,
  nivel: ehComponente(item) ? NIVEL_COMPONENTE : NIVEL_PRINCIPAL
}))

export const montarHierarquiaItens = itens => {
  if (!Array.isArray(itens) || itens.length === 0) {
    return []
  }

  const componentes = itens.filter(ehComponente)
  if (componentes.length === 0) {
    return listaPlana(itens)
  }

  const principais = itens.filter(item => !ehComponente(item))
  const indice = [indexarPor(principais, "Seq"), indexarPor(principais, "id")]
    .find(candidato => resolveTodos(componentes, candidato))

  if (!indice) {
    return listaPlana(itens)
  }

  const componentesPorPai = new Map()
  componentes.forEach(componente => {
    const pai = indice.get(Number(componente.ID_Composto))
    const filhos = componentesPorPai.get(pai.id) || []
    filhos.push({ ...componente, nivel: NIVEL_COMPONENTE })
    componentesPorPai.set(pai.id, filhos)
  })

  return principais.flatMap(principal => [
    { ...principal, nivel: NIVEL_PRINCIPAL },
    ...(componentesPorPai.get(principal.id) || [])
  ])
}
